import { render } from "./FrontofficeProfil.vue?vue&type=template&id=324097dd&scoped=true&ts=true"
import script from "./FrontofficeProfil.vue?vue&type=script&lang=ts"
export * from "./FrontofficeProfil.vue?vue&type=script&lang=ts"

import "./FrontofficeProfil.vue?vue&type=style&index=0&id=324097dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324097dd"]])

export default __exports__